// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-cta-buttons-mobile-menu[data-v-666ca564]{transition:.3s;position:fixed;bottom:0;background-color:#fff;width:100%;left:0;transform:translateY(100%);border-top-left-radius:1rem;border-top-right-radius:1rem}.product-cta-buttons-mobile-menu.open[data-v-666ca564]{transform:translateY(0%)}.ui-dark .product-cta-buttons-mobile-menu[data-v-666ca564]{background-color:#151727}.btn[data-v-666ca564]:hover{color:#774def !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
